import Page from '../..';
import './ToolsPrice.css';
import useStore from '../../../Hooks/useStore';
import Card from '../../../Card';
import React, { useEffect, useRef, useState } from 'react';
import SVG from '../../../SVG';
import Frame from '../../../Frame';
import useWindowDimensions from '../../../Hooks/useWindowDimensions';
import * as S from './styled';

export default function PageToolsPrice() {
  const [getters, setters] = useStore();
  const { height: screenHeight, width: sreenWidth } = useWindowDimensions();

  const {
    product: { getProduct, getCardProductList },
    user: { getUser },
  } = getters;

  const {
    product: { setProduct, findProductsByFilter },
  } = setters;
  const [currentPage, setCurrentPage] = useState(1);
  const [numberOfLines, setNumberOfLines] = useState(
    screenHeight > 875 ? 3 : 2,
  );
  const [numberOfColumns, setNumberOfColumns] = useState(5);
  let timerId: NodeJS.Timeout;
  useEffect(() => {
    clearTimeout(timerId);
    let calculatedNumberOfLines = 2;
    if (screenHeight > 875) {
      calculatedNumberOfLines = 3;
    }
    if (screenHeight <= 875) {
      calculatedNumberOfLines = 2;
    }
    setNumberOfLines(calculatedNumberOfLines);
    timerId = setTimeout(() => {
      filterProducts(1, calculatedNumberOfLines * numberOfColumns);
    }, 500);
    return () => {
      clearTimeout(timerId);
    };
  }, [screenHeight]);

  const gap = 20;
  const { lastPage: numberOfPages } = getProduct('filtered.price.meta');
  const [hoverPage, setHoverPage] = useState(-1);
  const frameRef = useRef<HTMLLabelElement>(null);
  const [frameWidth, setFrameWidth] = useState(0);
  const [] = useState();
  const [pageNumbers, setPageNumbers] = useState<Array<string | number>>([]);
  const [loading, setLoading] = useState(false);
  const filterProducts = (
    page = currentPage,
    limit = numberOfColumns * numberOfLines,
  ) =>
    new Promise(() => {
      setLoading(true);
      findProductsByFilter('price', page, limit)
        .then(() => {
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    });
  useEffect(() => {
    if (frameRef.current) {
      setFrameWidth(frameRef.current.offsetWidth);
    }
  }, [pageNumbers]);

  const onChange = (e: any) => {
    setProduct({
      field: 'filter.price',
      value: e.target.value,
    });
    setCurrentPage(1);
    filterProducts(1, numberOfColumns * numberOfLines);
  };

  const filialId = getUser('selectedFilialId');

  React.useEffect(() => {
    filterProducts(currentPage, numberOfColumns * numberOfLines);
  }, [filialId]);

  const conc = (str: string, n: number) =>
    n > 0 ? Array.from({ length: n }, () => str).join(' ') : '';

  const cardWidth = `calc((100vw - 4rem - ${
    numberOfColumns - 1
  } * ${gap}px) / ${numberOfColumns})`;

  const cardHeight = `calc((100vh - 67px  - 40px - ${numberOfLines} * 2 * 1rem - ${
    numberOfLines
  } * ${gap}px - (1rem + 38px + ${gap}px)) / ${numberOfLines})`;

  const onRequestPageHandler = (page: number) => {
    if (!loading && page >= 1 && numberOfPages > 1 && page <= numberOfPages) {
      setLoading(true);
      setCurrentPage(page);
      findProductsByFilter('price', page, numberOfColumns * numberOfLines)
        .then(() => {
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    }
  };

  const visiblePages = 5;
  const defaultPages = 2;
  const maxPageNumber = visiblePages + 2 * defaultPages;
  useEffect(() => {
    if (numberOfPages > maxPageNumber) {
      let leftPages = 0;
      let rightPages = 0;
      if (numberOfPages <= visiblePages) {
        leftPages = 0;
        rightPages = numberOfPages - 1;
      } else {
        leftPages = Math.min(
          currentPage - 1,
          Math.floor((visiblePages - 1) / 2),
        );
        rightPages = Math.min(
          numberOfPages - currentPage,
          Math.floor((visiblePages - 1) / 2),
        );
        if (currentPage - leftPages <= 1) {
          rightPages += leftPages + 1 - currentPage;
          leftPages = currentPage - 1;
        } else if (numberOfPages - currentPage <= rightPages) {
          leftPages += rightPages - (numberOfPages - currentPage);
          rightPages = numberOfPages - currentPage;
        }
        if (currentPage + rightPages === numberOfPages) {
          leftPages = Math.max(leftPages, visiblePages - rightPages - 1);
        }
      }
      const startPage = Math.max(1, currentPage - leftPages);
      const endPage = Math.min(numberOfPages, startPage + visiblePages - 1);
      const pageNumbers: any = [];
      for (let i = 1; i <= numberOfPages; i++) {
        if (
          i <= 2 ||
          i >= numberOfPages - 1 ||
          (i >= startPage && i <= endPage)
        ) {
          pageNumbers.push(i);
        } else if (i === defaultPages + 1 && startPage > defaultPages + 1) {
          pageNumbers.push('...');
        } else if (
          i === numberOfPages - defaultPages &&
          endPage < numberOfPages - defaultPages
        ) {
          pageNumbers.push('...');
        }
      }
      setPageNumbers(pageNumbers);
    } else {
      setPageNumbers(
        Array.from({ length: numberOfPages }).map((_, i) => i + 1),
      );
    }
  }, [currentPage, numberOfPages]);

  return (
    <Page className="page-tools-price">
      <div className="tools-price-container">
        <Card.Product.List
          cardWidth={cardWidth}
          cardHeight={cardHeight}
          numberOfColumns={numberOfColumns}
          products={getCardProductList()}
          gap={gap}
        />
        <div
          style={{
            display: 'flex',
            position: 'absolute',
            bottom: '1rem',
            background: 'white',
            width: 'fit-content',
            margin: 'auto auto',
            borderRadius: '10px',
            padding: '0.25rem 1rem',
            left: '50%',
            transform: 'translate(-50%, 0)',
          }}
        >
          <S.Control
            active={!(currentPage === 1 || !numberOfPages)}
            disabled={currentPage === 1 || !numberOfPages}
            onClick={() => {
              if (currentPage !== 1 && numberOfPages) onRequestPageHandler(1);
            }}
          >
            <SVG.Icon.SVGIconArrowDuplo
              color={
                currentPage === 1 || !numberOfPages ? '#a7a7a7' : '#11465d'
              }
              width={20}
              height={20}
            />
          </S.Control>
          <S.Control
            active={!(currentPage === 1 || !numberOfPages)}
            disabled={currentPage === 1 || !numberOfPages}
            onClick={() => {
              onRequestPageHandler(currentPage - 1);
            }}
          >
            <SVG.Icon.SVGIconBackSet
              color={
                currentPage === 1 || !numberOfPages ? '#a7a7a7' : '#11465d'
              }
              width={20}
              height={20}
            />
          </S.Control>

          <div
            style={{
              position: 'relative',
              transition: 'width 500ms',
              width: `${frameWidth + 20}px`,
              userSelect: 'none',
            }}
          >
            {(function () {
              const dotsIndexes = pageNumbers
                .map((element, index) => (element === '...' ? index : -1))
                .filter((index) => index !== -1);

              const dotsIndexesOne = dotsIndexes?.[0];
              const dotsIndexesTwo = dotsIndexes?.[1];

              return (
                <>
                  <div
                    style={{
                      position: 'absolute',
                      display: 'flex',
                      bottom: '0.25rem',
                      left: '50%',
                      transform: 'translate(-50%, 0)',
                      height: '100%',
                    }}
                  >
                    {pageNumbers.map((caracter, i) => {
                      let page: number;
                      if (typeof caracter === 'number') {
                        page = +caracter;
                      } else {
                        if (dotsIndexesOne && dotsIndexesTwo) {
                          if (dotsIndexesOne === i) {
                            page = currentPage - 1;
                          } else {
                            page = currentPage + 1;
                          }
                        } else {
                          if (defaultPages === i) {
                            page = currentPage - 1;
                          } else {
                            page = currentPage + 1;
                          }
                        }
                      }
                      return (
                        <label
                          key={i}
                          className="page-list"
                          onMouseEnter={() => setHoverPage(i)}
                          onMouseLeave={() => setHoverPage(-1)}
                          onClick={() => onRequestPageHandler(page)}
                          style={{
                            height: '-webkit-fill-available',
                            display: 'flex',
                            alignItems: 'end',
                          }}
                        >
                          <label
                            className="page-list-number"
                            style={{
                              fontSize:
                                currentPage === page
                                  ? 'x-large'
                                  : hoverPage === i
                                    ? 'larger'
                                    : 'medium',
                            }}
                          >
                            {caracter}
                          </label>
                          {i < pageNumbers.length - 1 &&
                          pageNumbers[i] !== '...' &&
                          pageNumbers[i + 1] &&
                          pageNumbers[i + 1] !== '...'
                            ? ','
                            : ''}
                        </label>
                      );
                    })}
                  </div>
                  <Frame ref={frameRef}>
                    {pageNumbers.map((caracter, i) => (
                      <label key={i} className="page-list">
                        <label
                          className="page-list-number"
                          style={{
                            fontSize: 'large',
                          }}
                        >
                          {caracter}
                        </label>
                        {i < pageNumbers.length - 1 &&
                        pageNumbers[i] !== '...' &&
                        pageNumbers[i + 1] &&
                        pageNumbers[i + 1] !== '...'
                          ? ','
                          : ''}
                      </label>
                    ))}
                  </Frame>
                </>
              );
            })()}
          </div>

          <S.Control
            active={!(currentPage === numberOfPages || !numberOfPages)}
            disabled={currentPage === numberOfPages || !numberOfPages}
            onClick={() => {
              onRequestPageHandler(currentPage + 1);
            }}
          >
            <SVG.Icon.SVGIconReturnRightSet
              color={
                currentPage === numberOfPages || !numberOfPages
                  ? '#a7a7a7'
                  : '#11465d'
              }
              width={20}
              height={20}
            />
          </S.Control>
          <S.Control
            active={!(currentPage === numberOfPages || !numberOfPages)}
            disabled={currentPage === numberOfPages || !numberOfPages}
            onClick={() => {
              if (currentPage !== numberOfPages)
                onRequestPageHandler(numberOfPages);
            }}
          >
            <SVG.Icon.SVGIconArrowRightDuplo
              color={
                currentPage === numberOfPages || !numberOfPages
                  ? '#a7a7a7'
                  : '#11465d'
              }
              width={20}
              height={20}
            />
          </S.Control>
        </div>
      </div>
    </Page>
  );
}
